var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3091 3.99989H4.72575C4.28372 3.99989 3.8598 4.17548 3.54724 4.48804C3.23468 4.80061 3.05908 5.22453 3.05908 5.66656V18.9999L6.39242 15.6666H16.3924C16.8344 15.6666 17.2584 15.491 17.5709 15.1784C17.8835 14.8658 18.0591 14.4419 18.0591 13.9999V11.7499",
    stroke: "#393838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5591 8.99989C16.9398 8.99989 18.0591 7.8806 18.0591 6.49989C18.0591 5.11918 16.9398 3.99989 15.5591 3.99989C14.1784 3.99989 13.0591 5.11918 13.0591 6.49989C13.0591 7.8806 14.1784 8.99989 15.5591 8.99989Z",
    stroke: "#393838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/messanger.55c08225cee7ec06b89559f5af92f600.svg";
export { ForwardRef as ReactComponent };